import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import {
  Row,
  Col,
  Button,
  Modal,
  Input,
  DatePicker,
  Checkbox,
  Select,
  Divider,
  Icon,
  message,
} from 'antd';
import * as queries from '~settings/queries';
import { Form } from '@ant-design/compatible';
import PropertySelector from '~components/property-selector-lazyload';
import { fetch } from '~helpers/graphql';
import { displayLocaleOptions, rankingOptions } from '~constants/property-field-options';

const { TextArea } = Input;
const PAGE_SIZE = 20;

class OperateTagModal extends React.Component {
  constructor() {
    super();

    this.state = {
      formLoading: false,
      properties: {
        pageNumber: 1,
        fetching: false,
        searchResults: [],
        selectedProperties: [],
        searchText: '',
        error: false,
        totalCount: 0,
      },
      landlords: {
        pageNumber: 1,
        fetching: false,
        searchResults: [],
        selectedLandlords: [],
        searchText: '',
        error: false,
        totalCount: 0,
      },
      // cities: {
      //   dataSource: [],
      //   pageNumber: 1,
      //   fetching: true,
      //   searchCities: [],
      //   selectedCities: [],
      //   searchText: '',
      //   error: false,
      // },
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.record !== this.props.record) {
      this.setState({
        properties: {
          ...this.state.properties,
          selectedProperties: this.props?.record?.tags?.properties || [],
        },
        // cities: {
        //   ...this.state.cities,
        //   selectedCities: this.props?.record?.tags?.cities || [],
        // },
        landlords: {
          ...this.state.landlords,
          selectedLandlords: this.props?.record?.tags?.landlords || [],
        },
      });

      if (this.props.record?.tags?.landlords) {
        this.props.form.setFieldsValue({
          landlordsCheckbox: this.props.record?.tags?.landlords.length > 0,
        });
      }

      // if (this.props.record?.tags?.cities) {
      //   this.props.form.setFieldsValue({
      //     citiesCheckbox: this.props.record?.tags?.cities.length > 0,
      //   });
      // }

      if (this.props.record?.tags?.properties) {
        this.props.form.setFieldsValue({
          propertiesCheckbox: this.props.record?.tags?.properties.length > 0,
        });
      }
    }
  }

  handleOkBtn = e => {
    e.preventDefault();
    const { properties, landlords } = this.state;
    const { getFieldValue } = this.props.form;

    this.state.landlords.error = false;
    // this.state.cities.error = false;
    this.state.properties.error = false;
    this.state.formLoading = true;

    // if (getFieldValue('citiesCheckbox') && cities.selectedCities?.length === 0) {
    //   this.state.cities = {
    //     ...cities,
    //     error: true,
    //   };
    // }

    if (getFieldValue('propertiesCheckbox') && properties.selectedProperties?.length === 0) {
      this.state.properties = {
        ...properties,
        error: true,
      };
    }

    if (getFieldValue('landlordsCheckbox') && landlords.selectedLandlords?.length === 0) {
      this.state.landlords = {
        ...landlords,
        error: true,
      };
    }

    if (!getFieldValue('landlordsCheckbox') && !getFieldValue('propertiesCheckbox')) {
      this.state.landlords = {
        ...landlords,
        error: true,
      };
      this.state.properties = {
        ...properties,
        error: true,
      };
      // this.state.cities = {
      //   ...cities,
      //   error: true,
      // };
    }

    this.setState(this.state);

    this.props.form.validateFields((err, values) => {
      if (!err && !this.state.properties.error & !this.state.landlords.error) {
        let query;
        const input = {
          name: values.name,
          displaySettings: values.displaySettings,
          ranking: values.ranking,
          tags: {
            // cityIds: cities.selectedCities.map(city => city.id),
            propertyIds: this.props.form.getFieldValue('propertiesCheckbox')
              ? properties.selectedProperties.map(property => property.id)
              : [],
            landlordIds: this.props.form.getFieldValue('landlordsCheckbox')
              ? landlords.selectedLandlords.map(landlord => landlord.id)
              : [],
          },

          updateDisplaySetting: true,
          updateTagMapping: true,
        };

        if (!values.endDatePermanent) {
          const formatStartDate = values?.startDate?.format('YYYY-MM-DD');
          const formatEndDate = values?.endDate?.format('YYYY-MM-DD');
          if (formatStartDate !== this.props.record?.startDate) {
            input.startDate = formatStartDate;
          }
          if (formatEndDate !== this.props.record?.endDate) {
            input.endDate = formatEndDate;
          }
        } else {
          input.endDate = null;
          input.startDate = null;
        }

        if (this.props.record) {
          query = queries.updateTag({
            ...input,
            id: this.props.record.id,
          });
        } else {
          query = queries.createTag({ ...input, type: 'TAG' });
        }

        fetch(query)
          .then(() => {
            this.props.onSuccess();
            this.handleClose();
            this.setState({ formLoading: false });
          })
          .catch(error => {
            if (error && error.message && error.message?.includes('tag already exists')) {
              this.props.form.setFields({
                name: {
                  value: this.props.form.getFieldValue('name'),
                  errors: [new Error(this.props.t('cms.tag_modal.error.name_exist_error'))],
                },
              });
            } else if (
              error &&
              error.message &&
              error.message?.includes('startDate cannot be less than today')
            ) {
              message.error(
                this.props.t('cms.tag_modal.form.toast.error.start_date_less_than_today'),
              );
            } else {
              message.error(this.props.t('cms.tag_modal.form.toast.error'));
            }
            this.setState({ formLoading: false });
          });
      } else {
        this.setState({ formLoading: false });
      }
    });
  };

  getDisplayLocaleSelectState = () => {
    const { form } = this.props;
    const displaySettings = form.getFieldValue('displaySettings');
    if (displaySettings?.length === displayLocaleOptions.length) {
      return 'All';
    }
    if (displaySettings?.length === 0) {
      return 'None';
    }
    return 'Some';
  };

  handleDisplayLocaleSelectAll = e => {
    this.props.form.setFieldsValue({
      displaySettings: e.target.checked
        ? displayLocaleOptions.map(option => option.value.toUpperCase().replace('-', '_'))
        : [],
    });
  };

  handleSearchData = (query, searchText, stateKey) => {
    const stateData = this.state[stateKey];
    if (searchText) {
      fetch(
        query({
          query: searchText,
          pageSize: PAGE_SIZE,
          pageNumber: 1,
        }),
      ).then(res => {
        if (res.search.edges) {
          this.setState({
            [stateKey]: {
              ...stateData,
              searchText: searchText,
              searchResults: res.search.edges,
              pageNumber: 2,
              totalCount: res.search.totalCount,
            },
          });
        }
      });
    } else {
      this.setState({
        [stateKey]: {
          ...stateData,
          searchText: '',
          searchResults: [],
          pageNumber: 1,
        },
      });
    }
  };

  handleSearchProperties = text => {
    this.handleSearchData(queries.searchPropertiesList, text, 'properties');
  };

  handleSearchLandlords = text => {
    this.handleSearchData(queries.searchLandlordList, text, 'landlords');
  };

  handleSearchCities = text => {
    if (text) {
      fetch(
        queries.searchCitiesList({
          query: text,
        }),
      ).then(res => {
        if (res.search.edges) {
          this.setState({
            cities: {
              ...this.state.cities,
              searchText: text,
              searchCities: res.search.edges,
            },
          });
        }
      });
    } else {
      this.setState({
        cities: {
          ...this.state.cities,
          searchText: [],
        },
      });
    }
  };

  disabledEndDate = current => {
    // Can not select days before today and today
    if (this.props.form.getFieldValue('startDate')) {
      return current && current < this.props.form.getFieldValue('startDate');
    } else {
      return null;
    }
  };

  disabledStartDate = current => {
    // Can not select days before today and today
    if (this.props.form.getFieldValue('endDate')) {
      return (
        current &&
        (current > this.props.form.getFieldValue('endDate') ||
          current <= moment().subtract(1, 'day'))
      );
    } else {
      return current && current <= moment().subtract(1, 'day');
    }
  };

  handleClose = () => {
    this.setState({
      properties: {
        ...this.state.properties,
        selectedProperties: [],
      },
      // cities: {
      //   ...this.state.cities,
      //   selectedCities: [],
      // },
      landlords: {
        ...this.state.landlords,
        selectedLandlords: [],
      },
    });
    this.props.form.resetFields();
    this.props.onClose();
  };

  fetchData = (query, searchText, stateKey, pageNumber, totalCount) => {
    const stateData = this.state[stateKey];
    const maxPage = Math.ceil(totalCount / PAGE_SIZE);

    if (stateData.fetching || !searchText || pageNumber > maxPage) return;

    this.setState({
      [stateKey]: {
        ...stateData,
        fetching: true,
      },
    });
    fetch(query({ query: searchText, pageSize: PAGE_SIZE, pageNumber }))
      .then(res => {
        if (res.search?.edges?.length) {
          this.setState({
            [stateKey]: {
              ...stateData,
              fetching: false,
              searchResults: stateData.searchResults.concat(res.search.edges),
              pageNumber: stateData.pageNumber + 1,
              totalCount: res.search.totalCount,
            },
          });
        } else {
          this.setState({
            [stateKey]: {
              ...stateData,
              fetching: false,
            },
          });
        }
      })
      .catch(() => {
        this.setState({
          [stateKey]: {
            ...stateData,
            fetching: false,
          },
        });
      });
  };

  fetchProperties = () => {
    const { properties } = this.state;
    this.fetchData(
      queries.searchPropertiesList,
      properties.searchText,
      'properties',
      properties.pageNumber,
      properties.totalCount,
    );
  };

  fetchLandlords = () => {
    const { landlords } = this.state;
    this.fetchData(
      queries.searchLandlordsList,
      landlords.searchText,
      'landlords',
      landlords.pageNumber,
      landlords.totalCount,
    );
  };

  render() {
    const { t, record } = this.props;
    const { getFieldDecorator, getFieldValue, setFields } = this.props.form;
    const { properties, landlords, formLoading } = this.state;

    return (
      <div className="tag-modal">
        <Modal
          visible={this.props.visible}
          width={880}
          className="tag-modal__content"
          footer={[
            <Button key="back" style={{ height: 40 }} onClick={this.handleClose}>
              {t('cms.tag_modal.header.btn.cancel')}
            </Button>,
            <Button
              key="submit"
              type="primary"
              style={{ height: 40 }}
              onClick={this.handleOkBtn}
              loading={formLoading}
              disabled={formLoading}
            >
              {t('cms.tag_modal.header.btn.confirm')}
            </Button>,
          ]}
          onCancel={this.handleClose}
        >
          <div className="tag-modal__tag-info">
            <h3 className="tag-modal__tag-info-title">{t('cms.tag_modal.header.title.add')}</h3>
            <div className="tag-modal__tag-info-form">
              <Form>
                <Row className="tag-modal__row" gutter={24}>
                  <Col span={24} style={{ textAlign: 'right' }}>
                    <Form.Item
                      className="tag-modal__field--tag-name"
                      label={t('cms.tag_modal.form.title.tag_name')}
                      required
                    >
                      {getFieldDecorator('name', {
                        validateTrigger: 'onBlur',
                        initialValue: record?.name,
                        rules: [
                          {
                            required: true,
                            message: t('cms.tag_modal.error.empty'),
                          },
                        ],
                      })(
                        <TextArea
                          className="tag-modal__input-text-area"
                          size="large"
                          placeholder={t('cms.tag_modal.form.placeholder.tag_name')}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item label={t('cms.tag_modal.form.title.effective_date')} required>
                      {getFieldDecorator('startDate', {
                        trigger: 'onChange',
                        initialValue: record?.startDate ? moment(record?.startDate) : null,
                        rules: [
                          {
                            required: !getFieldValue('endDatePermanent'),
                            message: t('cms.tag_modal.error.empty'),
                          },
                        ],
                      })(
                        <DatePicker
                          className="tag-modal__date-picker"
                          disabledDate={this.disabledStartDate}
                          disabled={getFieldValue('endDatePermanent')}
                          placeholder={t('cms.tag_modal.form.placeholder.start_date')}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="tag-modal__form-item--end-date"
                      label={getFieldDecorator('endDatePermanent', {
                        valuePropName: 'checked',
                        initialValue: record && !record?.startDate && !record?.endDate,
                      })(
                        <Checkbox
                          onChange={() => {
                            setFields({
                              endDate: null,
                              startDate: null,
                            });
                          }}
                        >
                          {t('cms.tag_modal.form.title.permanent')}
                        </Checkbox>,
                      )}
                    >
                      {getFieldDecorator('endDate', {
                        trigger: 'onChange',
                        initialValue: record?.endDate ? moment(record?.endDate) : null,
                        rules: [
                          {
                            required: !getFieldValue('endDatePermanent'),
                            message: t('cms.tag_modal.error.empty'),
                          },
                        ],
                      })(
                        <DatePicker
                          className="tag-modal__date-picker"
                          disabledDate={this.disabledEndDate}
                          placeholder={t('cms.tag_modal.form.placeholder.end_date')}
                          disabled={getFieldValue('endDatePermanent')}
                        />,
                      )}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={24}>
                    <Form.Item
                      label={t('cms.tag_modal.form.title.language')}
                      style={{ marginBottom: 0 }}
                    >
                      {getFieldDecorator('displaySettings', {
                        validateTrigger: 'onBlur',
                        initialValue: record?.displaySettings?.map(setting => {
                          return setting?.locale?.toUpperCase();
                        }),
                        rules: [
                          {
                            required: true,
                            message: t('cms.tag_modal.error.empty'),
                          },
                        ],
                      })(
                        <Select
                          mode="multiple"
                          className="tag-modal__display-setting__select"
                          placeholder={t('cms.tag_modal.form.placeholder.display_setting')}
                          dropdownRender={menu => (
                            <div>
                              <div
                                className="tag-modal__display-setting__select-all-container"
                                onMouseDown={e => e.preventDefault()}
                              >
                                <Checkbox
                                  className="tag-modal__display-setting__select"
                                  indeterminate={this.getDisplayLocaleSelectState() === 'Some'}
                                  onChange={this.handleDisplayLocaleSelectAll}
                                  checked={this.getDisplayLocaleSelectState() === 'All'}
                                >
                                  {t('cms.tag.header.btn.select_all')}
                                </Checkbox>
                              </div>
                              <Divider className="tag-modal__display-setting__divider" />
                              {menu}
                            </div>
                          )}
                        >
                          {displayLocaleOptions.map(item => (
                            <Select.Option
                              value={item.value.toUpperCase().replace('-', '_')}
                              key={item.value}
                            >
                              {item.name}
                            </Select.Option>
                          ))}
                        </Select>,
                      )}
                    </Form.Item>
                    <p className="tag-modal__display-setting__select-note">
                      <Icon
                        type="info-circle"
                        className="tag-modal__display-setting__select-note-icon"
                      />
                      {t('cms.tag_modal.form.note.language')}
                    </p>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={24}>
                    <Form.Item
                      label={t('cms.tag_modal.form.title.ranking')}
                      style={{ marginBottom: 0 }}
                    >
                      {getFieldDecorator('ranking', {
                        validateTrigger: 'onBlur',
                        initialValue: record?.ranking,
                        rules: [
                          {
                            required: true,
                            message: t('cms.tag_modal.error.empty'),
                          },
                        ],
                      })(
                        <Select
                          className="tag-modal__display-setting__select"
                          placeholder={t('cms.tag_modal.form.placeholder.ranking')}
                        >
                          {rankingOptions.map(item => (
                            <Select.Option
                              value={item.value.toUpperCase().replace('-', '_')}
                              key={item.value}
                            >
                              {item.value === 'BY_DEFAULT' ? (
                                <span>
                                  {item.name}
                                  <span className="tag-modal__display-setting__select-tip">
                                    {t('cms.tag_modal.form.tips.ranking.default')}
                                  </span>
                                </span>
                              ) : (
                                item.name
                              )}
                            </Select.Option>
                          ))}
                        </Select>,
                      )}
                    </Form.Item>
                    <p className="tag-modal__display-setting__select-note">
                      <Icon
                        type="info-circle"
                        className="tag-modal__display-setting__select-note-icon"
                      />
                      {t('cms.tag_modal.form.note.ranking')}
                    </p>
                  </Col>
                </Row>

                <div>
                  <p className="tag-modal__apply-level-title">
                    {t('cms.tag_modal.form.title.apply_level')}:
                  </p>
                  <Row gutter={8}>
                    <Col>
                      <div
                        className={classnames('tag-modal__form-item-wrapper', {
                          'tag-modal__form-item-wrapper--error': this.state.properties.error,
                        })}
                        onFocus={() => {
                          this.setState({
                            properties: {
                              ...this.state.properties,
                              error: false,
                            },
                          });
                        }}
                      >
                        <Form.Item
                          className="tag-modal__form-item--property-checkbox"
                          label={
                            <div className="tag-modal__properties-selector">
                              {getFieldDecorator('propertiesCheckbox', {
                                valuePropName: 'checked',
                              })(
                                <Checkbox>{t('cms.tag_modal.form.title.property_level')}</Checkbox>,
                              )}
                            </div>
                          }
                        >
                          <If condition={getFieldValue('propertiesCheckbox')}>
                            <div className="tag-modal__select-property-wrapper">
                              <p className="tag-modal__select-property-title">
                                {t('cms.tag_modal.form.content.applied_properties')}
                              </p>
                              <p className="tag-modal__select-property-summary">
                                {t('cms.tag_modal.form.tip.plz_select_properties')}
                              </p>
                              {getFieldDecorator('properties', {
                                rules: [
                                  {
                                    min: 1,
                                    type: 'array',
                                  },
                                ],
                              })(
                                <PropertySelector
                                  type="property"
                                  onChange={selectedProperties => {
                                    this.setState({
                                      properties: {
                                        ...properties,
                                        selectedProperties,
                                        searchText: '',
                                      },
                                    });
                                  }}
                                  onClose={() => {
                                    this.setState({
                                      properties: {
                                        ...properties,
                                        searchText: '',
                                        searchResults: [],
                                      },
                                    });
                                  }}
                                  onSearch={this.handleSearchProperties}
                                  className="tag-modal__select-property"
                                  properties={properties.searchResults}
                                  fetchLoading={properties.fetching}
                                  onFetchData={this.fetchProperties}
                                  propertiesSlugsExcluded={this.excludePropertySlugs}
                                  propertiesSelected={properties.selectedProperties}
                                  ref={element => {
                                    this.propertySelector = element;
                                  }}
                                  t={t}
                                />,
                              )}
                              {properties.error && (
                                <p className="tag-modal__form-item-error">
                                  {t('cms.tag_modal.error.empty')}
                                </p>
                              )}
                            </div>
                          </If>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row gutter={8}>
                    <Col>
                      <div
                        className={classnames('tag-modal__form-item-wrapper', {
                          'tag-modal__form-item-wrapper--error': this.state.landlords.error,
                        })}
                        onFocus={() => {
                          this.setState({
                            landlords: {
                              ...this.state.landlords,
                              error: false,
                            },
                          });
                        }}
                      >
                        <Form.Item
                          className="tag-modal__form-item--landlord-checkbox"
                          label={
                            <div className="tag-modal__properties-selector">
                              {getFieldDecorator('landlordsCheckbox', { valuePropName: 'checked' })(
                                <Checkbox>{t('cms.tag_modal.form.title.landlord_level')}</Checkbox>,
                              )}
                            </div>
                          }
                        >
                          <If condition={getFieldValue('landlordsCheckbox')}>
                            <div className="tag-modal__select-property-wrapper">
                              <p className="tag-modal__select-property-title">
                                {t('cms.tag_modal.form.content.applied_landlords')}
                              </p>
                              <p className="tag-modal__select-property-summary">
                                {t('cms.tag_modal.form.tip.plz_select_landlords')}
                              </p>
                              {getFieldDecorator('landlords', {
                                rules: [
                                  {
                                    min: 1,
                                    type: 'array',
                                  },
                                ],
                              })(
                                <PropertySelector
                                  type="landlord"
                                  onChange={selectedLandlords => {
                                    this.setState({
                                      landlords: {
                                        ...landlords,
                                        selectedLandlords,
                                        searchText: '',
                                      },
                                    });
                                  }}
                                  onClose={() => {
                                    this.setState({
                                      landlords: {
                                        ...landlords,
                                        searchText: '',
                                        searchResults: [],
                                      },
                                    });
                                  }}
                                  onSearch={this.handleSearchLandlords}
                                  className="tag-modal__select-property"
                                  properties={landlords.searchResults}
                                  fetchLoading={landlords.fetching}
                                  onFetchData={this.fetchLandlords}
                                  propertiesSlugsExcluded={this.excludePropertySlugs}
                                  propertiesSelected={landlords.selectedLandlords}
                                  ref={element => {
                                    this.propertySelector = element;
                                  }}
                                  t={t}
                                />,
                              )}
                              {landlords.error && (
                                <p className="tag-modal__form-item-error">
                                  {t('cms.tag_modal.error.empty')}
                                </p>
                              )}
                            </div>
                          </If>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  {/* <Row gutter={8}>
                    <Col>
                      <div
                        className={classnames('tag-modal__form-item-wrapper', {
                          'tag-modal__form-item-wrapper--error': this.state.cities.error,
                        })}
                        onFocus={() => {
                          this.setState({
                            cities: {
                              ...this.state.cities,
                              error: false,
                            },
                          });
                        }}
                      >
                        <Form.Item
                          className="tag-modal__form-item--city-checkbox"
                          label={
                            <div className="tag-modal__properties-selector">
                              {getFieldDecorator('citiesCheckbox', { valuePropName: 'checked' })(
                                <Checkbox>{t('cms.tag_modal.form.title.city_level')}</Checkbox>,
                              )}
                            </div>
                          }
                        >
                          <If condition={getFieldValue('citiesCheckbox')}>
                            <div className="tag-modal__select-property-wrapper">
                              <p className="tag-modal__select-property-title">
                                {t('cms.tag_modal.form.content.applied_cities')}
                              </p>
                              <p className="tag-modal__select-property-summary">
                                {t('cms.tag_modal.form.tip.plz_select_cities')}
                              </p>
                              {getFieldDecorator('cities', {
                                rules: [
                                  {
                                    min: 1,
                                    type: 'array',
                                  },
                                ],
                              })(
                                <PropertySelector
                                  onChange={selectedCities => {
                                    this.setState({
                                      cities: {
                                        ...cities,
                                        selectedCities,
                                        searchText: '',
                                      },
                                    });
                                  }}
                                  onClose={() => {
                                    this.setState({
                                      cities: {
                                        ...cities,
                                        searchText: '',
                                      },
                                    });
                                  }}
                                  onSearch={this.handleSearchCities}
                                  className="tag-modal__select-property"
                                  properties={
                                    cities.searchText !== ''
                                      ? cities.searchCities
                                      : cities.dataSource
                                  }
                                  fetchLoading={cities.fetching}
                                  onFetchData={() => {
                                    if (cities.fetching || cities.searchText !== '') return;
                                    this.setState({
                                      cities: {
                                        ...cities,
                                        fetching: true,
                                      },
                                    });
                                    fetch(
                                      queries.getCitiesList({
                                        pageSize: 100,
                                        pageNumber: cities.pageNumber,
                                      }),
                                    ).then(res => {
                                      if (res.cities.edges && res.cities.edges.length > 0) {
                                        this.setState({
                                          cities: {
                                            ...cities,
                                            fetching: false,
                                            dataSource: [].concat(
                                              cities.dataSource,
                                              res.cities.edges,
                                            ),
                                            pageNumber: cities.pageNumber + 1,
                                          },
                                        });
                                      } else {
                                        this.setState({
                                          cities: {
                                            ...cities,
                                            fetching: false,
                                          },
                                        });
                                      }
                                    });
                                  }}
                                  propertiesSlugsExcluded={this.excludePropertySlugs}
                                  propertiesSelected={cities.selectedCities}
                                  ref={element => {
                                    this.propertySelector = element;
                                  }}
                                  t={t}
                                />,
                              )}
                              {cities.error && (
                                <p className="tag-modal__form-item-error">
                                  {t('cms.tag_modal.error.empty')}
                                </p>
                              )}
                            </div>
                          </If>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row> */}
                </div>
              </Form>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

OperateTagModal.propTypes = {
  t: PropTypes.func.isRequired,
};

OperateTagModal.defaultProps = {
  t: () => {},
};

export default Form.create({ name: 'tag' })(OperateTagModal);
